import authStore from "../core/services/authStore/authStore";

export default class MenuService {
    async getMenus() {
        const isProduction = process.env.NODE_ENV === 'production';
        const baseUrl = isProduction 
            ? 'https://fkn.financialknowledge.net' 
            : 'http://localhost:4200';

        const transformItem = (item) => {
            // Handle "Manually Register Student" specially
            if (item.name === "Manually Register Student") {
                return {
                    label: item.name,
                    icon: item.vue_icon_class,
                    url: `${baseUrl}/sign-up1?check_confirm=1`, // Force full URL
                    target: "_blank", 
                    items: item.admin_tools ? item.admin_tools.map(transformItem) : null,
                };
            }

            // Default transformation for other items
            return {
                label: item.name,
                icon: item.vue_icon_class,
                to: item.vue_path ? item.vue_path : item.link_url || null,
                url: null, // Default to null (prefer 'to' for internal routes)
                target: null, // Default (no target)
                items: item.admin_tools ? item.admin_tools.map(transformItem) : null,
            };
        };
        
        const items = await authStore.getters.menus?.map(transformItem);
        
        // Add static items (Dashboard, Instructor menus, etc.)
        items?.unshift({
            "label": "Dashboard",
            "icon": "pi pi-fw pi-home",
            "to": "/",
            "target": null,
        });

        if (authStore.getters.userData?.is_instructor === 1) {
            items?.push(
                {
                    "label": "My Classes",
                    "icon": "pi pi-fw pi-box",
                    "to": "/class/search/instructor_classes",
                    "target": null,
                },
                {
                    "label": "Instructor Class Report",
                    "icon": "pi pi-fw pi-chart-bar",
                    "to": "/report/instructor/class",
                    "target": null,
                }
            );
        }

        if (authStore.getters.userData?.tool_group_id === 2) {
            items?.push({
                "label": "Teams Video",
                "icon": "pi pi-fw pi-video",
                "items": [
                    {
                        "label": "Video Clicks Report",
                        "icon": "pi pi-fw pi-chart-bar",
                        "to": "/report/video-clicks",
                        "target": null
                    },
                    {
                        "label": "Teams Videos List",
                        "icon": "pi pi-fw pi-list",
                        "to": "/report/video-list",
                        "target": null
                    }
                ]
            });
        }

        return { items };
    }
}